import { Form, Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListEditorTypes, TypeList } from "../../Constants/DataModelToolConstants";
import { questionModalSliceDispatch } from "../../Constants/ReduxConstants";
import ConvertFieldType from "../../Helpers/FieldTypeConverter";

interface RootState {
    questionModal: { questionToAdd: any };
}

const FieldTypeDropDown: React.FC<{ form: any; id?: string; defaultValue?: any }> = ({ form }) => {
    const questionToAdd = useSelector((state: RootState) => state.questionModal.questionToAdd);

    const dispatch = useDispatch();

    const typeList = TypeList.sort((a: any, b: any) => a.text > b.text ? 1 : -1);

    const typeOptions =
        typeList.map((str: any, index: number) => ({ key: str.text, text: str.text, value: str.text }));

    const onFieldTypeDropDownChange = (value: string) => {
        form.setFields([
            {
                name: 'Max Length',
                errors: []
            },
            {
                name: 'Type',
                errors: []
            }
        ]);
        const convertedType = ConvertFieldType(value, "value")
        const convertedShape = ConvertFieldType(value, "shape")
        const convertedVariant = ConvertFieldType(value, "variant")

        if (value === "yes|no") {
            questionToAdd.options = []
            questionToAdd.options.push("Yes")
            questionToAdd.options.push("No")
            questionToAdd.values = []
            questionToAdd.values.push("Yes")
            questionToAdd.values.push("No")
        }
        else if (!ListEditorTypes.includes(value)) {
            questionToAdd.options = []
            questionToAdd.values = []
        }

        questionToAdd.type = convertedType;
        questionToAdd.shape = convertedShape;
        questionToAdd.variant = convertedVariant;

        dispatch({ type: questionModalSliceDispatch.setQuestionToAdd, payload: { ...questionToAdd, ['selectedType']: value } })
    }

    return (
        <Form.Item rules={[{
            validator(rule, value) {
                return new Promise((resolve, reject) => {
                    if ((value == "integer"
                        || value == "integer-text"
                        || value == "number")
                        && questionToAdd.maxLength > 17) {
                        reject('Max length for ' + value + ' cannot exceed 17.');
                    }
                    else {
                        resolve(undefined);
                    }
                })
            }
        }]} name="Type" label="Type">
            <Select
                placeholder='Select Field Type'
                options={typeOptions}
                defaultValue={questionToAdd.selectedType}
                onChange={onFieldTypeDropDownChange}
                id="selectedType"
            />
        </Form.Item>
    )
}

export default FieldTypeDropDown